<template>
  <QBadge
    :color="color"
    class="
      recommended-badge
      tw-absolute
      tw-top-5 -tw-left-5 lg:tw-left-0 tw-z-[5]
      tw-h-[30px] lg:tw-h-8 tw-pl-7 lg:tw-pl-2 tw-pr-2 tw-min-w-[85px] tw-w-auto tw-whitespace-nowrap
      !tw-rounded-md
      !tw-rounded-l-none
      tw-flex tw-items-center tw-justify-center
      tw-text-mb-title-6 lg:tw-text-dt-title-6
    "
    :label="$t('global.recommended')"
  />
</template>

<script setup lang="ts">
defineProps({
  recommended: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'secondary',
  },
})
</script>

<style scoped>
.recommended-badge {
  background: var(--theme-color-secondary) !important;
  color: var(--theme-color-inverted-secondary) !important;
}
</style>
